import { useState, useCallback } from 'react'
import { CognitoUser } from 'amazon-cognito-identity-js'
import UserPool from '../cognito/config'

// TODO These reset password use cases should be implemented stateless in the
// cognito wrapper at ../cognito and this stateful hook should only consume them
const useForgotPassword = () => {
  const defaultRequestPasswordResetState = {
    isLoading: false,
    isError: false,
    error: null,
    isSuccess: false,
    data: null,
    isResending: false,
  }
  const [requestPasswordResetState, setRequestPasswordResetState] = useState(
    defaultRequestPasswordResetState,
  )
  const setDefaultRequestPasswordResetState = () =>
    setRequestPasswordResetState(defaultRequestPasswordResetState)

  const defaultResetPasswordState = {
    isLoading: false,
    isError: false,
    error: null,
    isSuccess: false,
    data: null,
  }
  const [resetPasswordState, setResetPasswordState] = useState(
    defaultResetPasswordState,
  )
  const setDefaultResetPasswordState = () =>
    setResetPasswordState(defaultResetPasswordState)

  const sendVerificationCode = useCallback(username => {
    setRequestPasswordResetState(requestResetState => ({
      ...requestResetState,
      isLoading: true,
    }))

    const user = new CognitoUser({
      Username: username,
      Pool: UserPool,
    })

    user.forgotPassword({
      onSuccess: data => {
        // console.log('forgotPassword success', { data })
        setRequestPasswordResetState(requestResetState => ({
          ...requestResetState,
          isLoading: false,
          isSuccess: true,
          data,
        }))
      },
      onFailure: error => {
        // console.log('forgotPassword failure', { error })
        setRequestPasswordResetState(requestResetState => ({
          ...requestResetState,
          isLoading: false,
          isError: true,
          error,
        }))
      },
    })
  }, [])

  // NOTE: we don't use this method since we get an error when using the
  // resetPassword with the code sent by resendConfirmationCode
  const resendConfirmationCode = useCallback(username => {
    setRequestPasswordResetState(requestResetState => ({
      ...requestResetState,
      isLoading: true,
      isResending: true,
      isSuccess: false,
    }))

    const user = new CognitoUser({
      Username: username,
      Pool: UserPool,
    })

    user.resendConfirmationCode({
      onSuccess: data => {
        // console.log('resendConfirmationCode success', { data })
        setRequestPasswordResetState(requestResetState => ({
          ...requestResetState,
          isLoading: false,
          isResending: false,
          isSuccess: true,
        }))
      },
      onFailure: error => {
        // console.log('resendConfirmationCode error', { error })
        setRequestPasswordResetState(requestResetState => ({
          ...requestResetState,
          isLoading: false,
          isResending: false,
          isError: true,
          error,
        }))
      },
    })
  }, [])

  const resetPassword = useCallback(
    (username, verificationCode, newPassword) => {
      setResetPasswordState(resetState => ({
        ...resetState,
        isLoading: true,
      }))

      const user = new CognitoUser({
        Username: username,
        Pool: UserPool,
      })

      user.confirmPassword(verificationCode, newPassword, {
        onFailure: error => {
          // console.log('resetPassword error', { error })
          setResetPasswordState(resetState => ({
            ...resetState,
            isLoading: false,
            isError: true,
            error,
          }))
        },
        onSuccess: data => {
          // console.log('resetPassword success', { data })
          setResetPasswordState(resetState => ({
            ...resetState,
            isLoading: false,
            isSuccess: true,
            data,
          }))
        },
      })
    },
    [],
  )

  return {
    requestPasswordResetState,
    setDefaultRequestPasswordResetState,
    sendVerificationCode,
    resendConfirmationCode,
    resetPasswordState,
    setDefaultResetPasswordState,
    resetPassword,
  }
}

export { useForgotPassword }
